module.exports = __webpack_public_path__ + "roboto-thin-webfont.0cc9ab9863e726a5619f.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-thin-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-thin-webfont.woff2
// module chunks = styles